module.exports = __webpack_public_path__ + "img/gibraltar.b614c081.png";